<div class="position-relative">
  <div #stickyPopover="stickyPopover"
       [stickyPopover]="popContent"
       [autoClose]="false"
       [animation]="false"
       [style.marginLeft.px]="marginLeftPopover"
       [closeDelay]="popoverCloseDelay"
       (outMouseEnterPopover)="fadeInSlider()"
       (outMouseLeavePopover)="fadeOutSlider()"
       [placement]="optionsViewPlacement"
       popoverClass='sky-layers-slider-popover'
       container="body"
       triggers="manual"
       [style]="optionsViewStyle">
  </div>
  <input #sliderBar
         type="range"
         class="form-range my-2"
         min="1"
         max="{{maximumSliderValue}}"
         [style.opacity]="sliderOpacity"
         [(ngModel)]="currentSliderValue"
         (ngModelChange)="onSliderEvent()"
         (mousemove)="onMouseHover()"
         (mouseleave)="onMouseLeave()">
</div>

<ng-template #popContent>
  <ng-content select="popContent">
  </ng-content>
</ng-template>
